import React from 'react';
import { InputLabel, MenuItem, Select } from '@mui/material';
import { StyledDiv, StyledFormControl } from '../GameFinder.styled';

type GameFinderFormControlProps<T> = {
  value: T | null;
  setFunction: (value: T) => void;
  data: T[];
  label: string;
};

const GameFinderFormControl = <T extends string | number>({
  value,
  setFunction,
  data,
  label,
}: GameFinderFormControlProps<T>) => {
  return (
    <StyledDiv>
      <StyledFormControl fullWidth>
        <InputLabel id={`${label.toLowerCase()}-select-label`}>
          {label}
        </InputLabel>
        <Select
          labelId={`${label.toLowerCase()}-select-label`}
          value={value ?? ''}
          onChange={(e) => setFunction(e.target.value as T)}
        >
          {data.map((item) => (
            <MenuItem key={item} value={item}>
              {item}
            </MenuItem>
          ))}
        </Select>
      </StyledFormControl>
    </StyledDiv>
  );
};

export default GameFinderFormControl;
